<template>
  <div id="app">
    <Navigation
      :nav-links="navLinks"
      :image-path="require('./assets/logo_small.png')"
      background="#444"
      link-color="#ddd"
      hover-background="#888"
    />
    <router-view />
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
export default {
  components: {
    Navigation
  },
  data: () => ({
    navLinks: [
      {
        text: 'Home',
        path: '/home',
        icon: 'ion-ios-home'
      },
      {
        text: 'Usuários',
        path: '/users',
        icon: 'ion-ios-people'
      },
      {
        text: 'Sobre',
        path: '/about',
        icon: 'ion-ios-business'
      }
    ]
  })
}
</script>

<style lang="scss">
@import "https://unpkg.com/ionicons@4.2.2/dist/css/ionicons.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";

table.b-table[aria-busy="false"] {
  opacity: 1;
}

table.b-table[aria-busy="true"] {
  opacity: 0.6;
}
@media (max-width: 768px) {
  .table-bordered td {
    border: none !important;
  }
  .table td {
    border-top: none !important;
  }
}

figure {
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 10px;
  margin-inline-end: 0;
}
body {
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>